import { Move, MOVE_DAMAGE_CLASS_PHYSICAL, isFreezeDryMove, isHydroSteamMove, isKakuteiCriticalMove, isKaragenkiMove, isKataYaburiMove, isKazeMove, isMultiAttackMove, isOtoMove, isPhotonGeyserMove, isPsyshockMove, isRenzokuMove, isRevelationDanceMove, isShellSideArmMove, isTamaMove, isTechnoBlastMove, isTerabrastMove, isWavesOfTheEarthMove, isWeatherBallMove } from "../../move/move";
import { otherSetting, WEATHER_HARE, WEATHER_OOHIDERI, WEATHER_RANKIRYUU, WEATHER_AME, WEATHER_OOAME, WEATHER_SUNA, WEATHER_YUKI, BATTLE_FIELD_PSYCHO_SAIKO, BATTLE_FIELD_EREKI, BATTLE_FIELD_MISUTO, BATTLE_FIELD_GLASS } from "../../OtherSetting";
import { PokemonV2 } from "../../pokemon/pokemon";
import {
  POKEMON_TYPE_NORMAL,
  POKEMON_TYPE_FIGHTING,
  POKEMON_TYPE_FLYING,
  POKEMON_TYPE_ELECTRIC,
  POKEMON_TYPE_ICE,
  POKEMON_TYPE_FIRE,
  POKEMON_TYPE_WATER,
  POKEMON_TYPE_FAIRY,
  POKEMON_TYPE_STERA,
  POKEMON_TYPE_ROCK,
  POKEMON_TYPE_GRASS,
  POKEMON_TYPE_PSYCHIC,
  POKEMON_TYPE_GROUND,
} from "../../types/type";
import { getDamageRelations } from "../type";
import { canScrappy } from "../pokemon/battle-state";
import { isBurnedStatus, isPoisonedStatus } from "../pokemon/status";
import { calc_attack } from "./core";
import { calc_damage_rate } from "./rate";
import { calc_defence } from "./core";
import { getPlateType, getArceusEffectiveType } from "../../pokemon/PlateUtils";
import { ARCEUS_SPECIES_ID } from "../../pokemon/arceus";

import { calc_move_power } from "../../calc-damage/calc_move_power";
import { calcOffenceEffectiveValueCached, calcDefenceEffectiveValueCached } from "./effective-cache";
import { tatamikomi, listToMapper, calcRate, calcRateMultiHit, calcKakuteiRansuu } from "./hit";
import { computeShellSideArmDamage } from "./shell-side-arm";
import { computeWithRand, copiedDummyInfoForDefencePokemon, calc_五捨五超入_gosutegoire, calcRankedValue } from "./core-utils";
import type { damageRateMapper, retCalc } from "../../types/damage";
import { per_150, per_200, per_225, per_050, per_120, per_100 } from "./constants";
import { hasWeatherBlockAbility, isBouon, isBoudan, isChikuden, isChosui, isDenkiEngine, isErekiSkin, isFailySkin, isFreezeSkin, isHiraishin, isHitodenashi, isHuyuu, isKansouHada, isKazenori, isKongariBody, isKonjou, isMoraibi, isNormalSkin, isSkySkin, isTekiourixyoku, isTennen, isUruoiVoice, isYobimizu } from "../ability";
import { resolveRevelationDanceMoveType } from "../revelation-dance";
import { resolveTechnoBlastMoveType } from "../techno-blast";
import { resolveMultiAttackMoveType } from "../multi-attack";
export { copiedDummyInfoForDefencePokemon } from "./core-utils";
export { calc_五捨五超入_gosutegoire, calcRankedValue } from "./core-utils";
export { per_110, per_110_punchglobe, per_150, per_200, per_225, per_050, per_075, per_130, per_130_normal_jewel_field, per_120, per_100, per_125, per_133_3, per_130_taranzisuta } from "./constants";


// moved to lib/damage/core-utils


export function calc_interface({
  offencePokemonList,
  deffencePokemon,
  deffenceDummyPokemon,
  otherSetting,
  attackMode = false,
}: {
  offencePokemonList: PokemonV2[];
  deffencePokemon: PokemonV2;
  deffenceDummyPokemon: PokemonV2;
  otherSetting: otherSetting;
  attackMode?: boolean;
}): retCalc {
  // 防御側はダミー情報込みでコピーしてから実値を算出する
  const baseDefencePokemon = copiedDummyInfoForDefencePokemon({
    deffencePokemon,
    deffenceDummyPokemon,
  });
  const defencePokemonContext: PokemonV2 = {
    ...baseDefencePokemon,
    effective_value: calcDefenceEffectiveValueCached(baseDefencePokemon),
  };

  const damageMapList: Array<{ [name: number]: number }> = [];
  // 連続技の確率計算に使う「初撃の乱数分布」を別で保持する
  const firstHitRandomTable: { [name: number]: number } = {};
  let shellSideArmDetails: retCalc['shell_side_arm_details'];

  offencePokemonList.forEach((offencePokemon) => {
    let move = offencePokemon.selected_move;
    if (!move) {
      return;
    }
    // 呼び出し元の配列を汚染しないように攻撃側もコピーしておく
    const offencePokemonContext: PokemonV2 = {
      ...offencePokemon,
      effective_value: calcOffenceEffectiveValueCached(offencePokemon),
    };

    // マルチアタックはメモリに応じてタイプが変化する
    if (isMultiAttackMove(move)) {
      const multiAttackType = resolveMultiAttackMoveType(offencePokemonContext);
      if (multiAttackType) {
        move = { ...move, type: multiAttackType };
        offencePokemonContext.selected_move = move;
      }
    }

    const rateMapper = {
      compatibilityRate: getCompatibilityTypeRate(
        offencePokemonContext,
        defencePokemonContext,
        otherSetting
      ),
      sameTypeRate: calcOffenceMoveTypeRate(
        move,
        offencePokemonContext,
        otherSetting,
        defencePokemonContext,
        attackMode
      ),
    } as damageRateMapper;

    // 連続技は指定回数、通常は1回扱い
    const hitNumber =
      isRenzokuMove(move) && offencePokemonContext.selected_hit_number
        ? offencePokemonContext.selected_hit_number
        : 1;

    for (let loopHitNumber = 1; loopHitNumber <= hitNumber; loopHitNumber++) {
      const isCritical = resolveCriticalState(
        offencePokemonContext,
        defencePokemonContext,
        move,
        loopHitNumber
      );

      let calcedList: number[];

      if (isShellSideArmMove(move)) {
        const res = computeShellSideArmDamage({
          move,
          offencePokemon: offencePokemonContext,
          deffencePokemon: defencePokemonContext,
          rateMapper,
          loopHitNumber,
          otherSetting,
          isCritical,
          attackMode,
          calcWithRand: runCalcWithRand,
        });

        if (loopHitNumber === 1) {
          const physicalKakuteiRansuu = calcKakuteiRansuu(
            defencePokemonContext.effective_value.hp,
            res.physical.min,
            res.physical.max,
            1
          );
          const specialKakuteiRansuu = calcKakuteiRansuu(
            defencePokemonContext.effective_value.hp,
            res.special.min,
            res.special.max,
            1
          );
          shellSideArmDetails = {
            physical_damage: {
              min: res.physical.min,
              max: res.physical.max,
              text: `物理: ${physicalKakuteiRansuu.s}${physicalKakuteiRansuu.n}発【${res.physical.min}～${res.physical.max}】`,
            },
            special_damage: {
              min: res.special.min,
              max: res.special.max,
              text: `特殊: ${specialKakuteiRansuu.s}${specialKakuteiRansuu.n}発【${res.special.min}～${res.special.max}】`,
            },
            selected_type: res.selectedType,
          };
        }

        calcedList = res.selectedList;
      } else {
        calcedList = runCalcWithRand(
          move,
          offencePokemonContext,
          defencePokemonContext,
          rateMapper,
          loopHitNumber,
          otherSetting,
          isCritical,
          attackMode
        );
      }

      const mappedList = listToMapper(calcedList);
      damageMapList.push(...mappedList);

      if (loopHitNumber === 1 && mappedList[0]) {
        Object.entries(mappedList[0]).forEach(([damage, count]) => {
          const damageValue = Number(damage);
          firstHitRandomTable[damageValue] =
            (firstHitRandomTable[damageValue] || 0) + (count as number);
        });
      }
    }
  });

  const retTatamikomi = tatamikomi(damageMapList);
  return to_retCalc_v2(
    defencePokemonContext,
    retTatamikomi,
    firstHitRandomTable,
    shellSideArmDetails
  );
}
// 連続技や確定急所フラグを考慮して急所判定を一元化
function resolveCriticalState(
  offencePokemon: PokemonV2,
  deffencePokemon: PokemonV2,
  move: Move,
  loopHitNumber: number
): boolean {
  // ひとでなし - 相手がどく状態のとき、技が急所に当たる
  if (isHitodenashi(offencePokemon) && isPoisonedStatus(deffencePokemon.other_setting)) {
    return true;
  }
  if (isKakuteiCriticalMove(move)) {
    return true;
  }
  const criticalHitCount = offencePokemon.other_setting?.critical_hit_count ?? 0;
  if (isRenzokuMove(move)) {
    return criticalHitCount >= loopHitNumber;
  }
  return criticalHitCount > 0;
}

function to_retCalc_v2(
  deffencePokemon: PokemonV2,
  retTatamikomi: {
    [name: number]: number;
  },
  firstHitRandomTable: {
    [name: number]: number;
  },
  shellSideArmDetails?: retCalc['shell_side_arm_details']
): retCalc {
  const damageList = Object.keys(retTatamikomi).map((v) => parseInt(v));
  
  // ダメージが存在しない場合の処理
  if (damageList.length === 0 || Math.max(...damageList) === 0) {
    return {
      text: "",
      min_damage: 0,
      max_damage: 0,
      random_table: {},
      shell_side_arm_details: shellSideArmDetails
    };
  }
  
  const maxDamage = Math.max(...damageList);
  const minDamage = Math.min(...damageList);
  
  const headInfo = calcKakuteiRansuu(
    deffencePokemon.effective_value.hp,
    minDamage,
    maxDamage,
    1
  );
  let retstr = `${headInfo.s}${headInfo.n}発【${minDamage}～${maxDamage}】`;
  
  // 乱数の場合は確率を計算して表示
  if (headInfo.s === "乱数") {
    if (headInfo.n === 1) {
      // 1発の場合は従来通り
      const rate = calcRate(deffencePokemon.effective_value.hp, retTatamikomi);
      retstr += `\n(${rate}%)`;
    } else {
      // 2発以上の場合は複数回攻撃用の確率計算を使用
      const rate = calcRateMultiHit(
        deffencePokemon.effective_value.hp,
        firstHitRandomTable,
        headInfo.n
      );
      retstr += `\n(${rate}%)`;
    }
  }
  
  return {
    text: retstr,
    min_damage: minDamage,
    max_damage: maxDamage,
    random_table: firstHitRandomTable,
    shell_side_arm_details: shellSideArmDetails
  };
}

// moved: calcKakuteiRansuu to lib/damage/hit

// moved: calcRate / calcRateMultiHit to lib/damage/hit

function runCalcWithRand(
  move: Move,
  offencePokemon: PokemonV2,
  deffencePokemon: PokemonV2,
  rateMapper: damageRateMapper,
  loopHitNumber: number,
  otherSetting: otherSetting,
  isCritical: boolean = false,
  attackMode: boolean = false
): number[] {
  return computeWithRand(
    (args) =>
      calc({
        ...args,
      }),
    {
      move,
      offencePokemon,
      deffencePokemon,
      rateMapper,
      loopHitNumber,
      otherSetting,
      isCritical,
      attackMode,
    }
  );
}


// per_* 定数は lib/damage/constants から参照



export function calc({
  move,
  offencePokemon,
  deffencePokemon,
  rateMapper,
  loopHitNumber,
  otherSetting,
  isCritical = false,
  attackMode = false,
}: {
  move: Move;
  offencePokemon: PokemonV2;
  deffencePokemon: PokemonV2;
  rateMapper: damageRateMapper;
  loopHitNumber: number;
  otherSetting: otherSetting;
  isCritical?: boolean;
  attackMode?: boolean;
}) {
  const isKatayaburiMoveByName = isKataYaburiMove(move);
  const isPhotonGeyser = isPhotonGeyserMove(move);
  const isPsyshock = isPsyshockMove(move);
  const photonGeyserAttackRank = (isTennen(deffencePokemon) && !isKatayaburiMoveByName)
    ? 0
    : (offencePokemon.rankCorrection?.attack ?? 0);
  const photonGeyserSpecialAttackRank = (isTennen(deffencePokemon) && !isKatayaburiMoveByName)
    ? 0
    : (offencePokemon.rankCorrection?.special_attack ?? 0);
  const photonGeyserUsesAttack =
    isPhotonGeyser &&
    calcRankedValue(offencePokemon.effective_value.attack, photonGeyserAttackRank) >
    calcRankedValue(offencePokemon.effective_value.special_attack, photonGeyserSpecialAttackRank);
  // サイコショック系やフォトンゲイザーの参照先（攻撃/特攻）をここで確定

  // 【1】威力の補正値
  const power = calc_move_power({
    move,
    offencePokemon,
    deffencePokemon,
    // rateMapper,
    loopHitNumber,
    otherSetting,
  });

  // 【3】攻撃の補正値
  const attack = calc_attack({
    deffencePokemon,
    loopHitNumber,
    move,
    offencePokemon,
    rateMapper,
    otherSetting,
    isCritical,
  });


  // 【5】防御の補正値
  const defence = calc_defence({
    deffencePokemon,
    loopHitNumber,
    move,
    offencePokemon,
    rateMapper,
    otherSetting,
    isCritical,
  });

  // 【6】最終防御
  let finalDefence = defence;
  // 天候補正はタイプ変化（アルセウスのプレート/シルヴァディのメモリ）を考慮する
  // ただしテラスタル（ステラ以外）の場合はテラスタイプを優先する
  const defenceTypeListForWeather =
    deffencePokemon.terasu_type &&
    deffencePokemon.terasu_type > 0 &&
    deffencePokemon.terasu_type !== POKEMON_TYPE_STERA
      ? [deffencePokemon.terasu_type]
      : getArceusEffectiveType(deffencePokemon as any);
  // 天気「すなあらし」かついわタイプのポケモンの場合は特防1.5倍(端数切捨て、サイコショック系技は除外)
  if (otherSetting.weather === WEATHER_SUNA && 
      move.damage_class_number !== MOVE_DAMAGE_CLASS_PHYSICAL &&
      !isPsyshock &&
      !photonGeyserUsesAttack &&
      defenceTypeListForWeather.includes(POKEMON_TYPE_ROCK)) {
    finalDefence = Math.floor(defence * per_150);
  }
  // 天気「ゆき」かつこおりタイプのポケモンの場合は防御1.5倍(端数切捨て、サイコショック系技も適用)
  if (otherSetting.weather === WEATHER_YUKI && 
      (move.damage_class_number === MOVE_DAMAGE_CLASS_PHYSICAL || isPsyshock ||
       photonGeyserUsesAttack) &&
      defenceTypeListForWeather.includes(POKEMON_TYPE_ICE)) {
    finalDefence = Math.floor(defence * per_150);
  }

  // 防音・防弾・かぜのり特性による技無効化チェック
  if (
    (isBouon(deffencePokemon) && isOtoMove(move)) ||
    (isBoudan(deffencePokemon) && isTamaMove(move)) ||
    (isKazenori(deffencePokemon) && isKazeMove(move))
  ) {
    return 0;
  }


  // 【7】ダメージの補正値
  const damageRateCalced = calc_damage_rate({
    deffencePokemon,
    loopHitNumber,
    move,
    offencePokemon,
    rateMapper,
    otherSetting,
    isCritical,
  });

  // 【8】最終ダメージ

  // 基本ダメージ部分計算
  let a = Math.floor((50 * 2) / 5 + 2);
  a = Math.floor((a * power * attack) / finalDefence);
  a = Math.floor(a / 50 + 2);

  // 順番を守って各種倍率を掛け算していく


  let tempMoveType = offencePokemon.selected_move?.type;

  // めざめるダンスは使用者のタイプ（タイプ1/テラスタル）で攻撃する
  if (isRevelationDanceMove(offencePokemon.selected_move)) {
    tempMoveType = resolveRevelationDanceMoveType(offencePokemon);
  }

  // テクノバスターはカセットに応じてタイプが変化する
  if (isTechnoBlastMove(offencePokemon.selected_move)) {
    const technoBlastType = resolveTechnoBlastMoveType(offencePokemon);
    if (technoBlastType) {
      tempMoveType = technoBlastType;
    }
  }

  // マルチアタックはメモリに応じてタイプが変化する
  if (isMultiAttackMove(offencePokemon.selected_move)) {
    const multiAttackType = resolveMultiAttackMoveType(offencePokemon);
    if (multiAttackType) {
      tempMoveType = multiAttackType;
    }
  }
  
  // エアロック・ノーてんき特性チェック（天気無効化）
  const weatherBlocked = hasWeatherBlockAbility(offencePokemon) || hasWeatherBlockAbility(deffencePokemon);

  // ウェザーボール使用時の天気によるタイプ変更
  if (isWeatherBallMove(offencePokemon.selected_move) && !weatherBlocked) {
    if (otherSetting.weather === WEATHER_HARE || otherSetting.weather === WEATHER_OOHIDERI) {
      tempMoveType = POKEMON_TYPE_FIRE;
    } else if (otherSetting.weather === WEATHER_AME || otherSetting.weather === WEATHER_OOAME) {
      tempMoveType = POKEMON_TYPE_WATER;
    } else if (otherSetting.weather === WEATHER_YUKI) {
      tempMoveType = POKEMON_TYPE_ICE;
    } else if (otherSetting.weather === WEATHER_SUNA) {
      tempMoveType = POKEMON_TYPE_ROCK;
    }
  }

  // ノーマルスキンは使用する技を全てノーマルタイプにする（天気補正の判定もノーマルとして扱う）
  if (isNormalSkin(offencePokemon)) {
    tempMoveType = POKEMON_TYPE_NORMAL;
  }

  // おおひでり（ひざしがとてもつよい）はみずタイプの攻撃技を無効化する
  if (otherSetting.weather === WEATHER_OOHIDERI && !weatherBlocked && tempMoveType === POKEMON_TYPE_WATER) {
    return 0;
  }

  // おおあめ（つよいあめ）はほのおタイプの攻撃技を無効化する
  if (otherSetting.weather === WEATHER_OOAME && !weatherBlocked && tempMoveType === POKEMON_TYPE_FIRE) {
    return 0;
  }

  // 天気
  if ((otherSetting.weather === WEATHER_HARE || otherSetting.weather === WEATHER_OOHIDERI) && !weatherBlocked) {
    if (tempMoveType === POKEMON_TYPE_FIRE) { 
      a = calc_五捨五超入_gosutegoire(a * per_150);
    } else if (tempMoveType === POKEMON_TYPE_WATER && !isHydroSteamMove(offencePokemon.selected_move)) {
      // ハイドロスチームは晴れ時の水タイプ技減少を無視
      a = calc_五捨五超入_gosutegoire(a * per_050);
    }
  }
  if ((otherSetting.weather === WEATHER_AME || otherSetting.weather === WEATHER_OOAME) && !weatherBlocked) {
    if (tempMoveType === POKEMON_TYPE_FIRE) {
      a = calc_五捨五超入_gosutegoire(a * per_050);
    } else if (tempMoveType === POKEMON_TYPE_WATER) {
      a = calc_五捨五超入_gosutegoire(a * per_150);
    }
  }

  // 急所のとき1.5倍の補正をかける
  if (isCritical) {
    a = calc_五捨五超入_gosutegoire(a * per_150);
  }

  // 乱数
  a = Math.floor(a * rateMapper.randRate);

  // タイプ一致補正
  a = calc_五捨五超入_gosutegoire(a * rateMapper.sameTypeRate);

  // タイプ相性
  a = Math.floor(a * rateMapper.compatibilityRate);

  // やけど状態の補正
  if (
    isBurnedStatus(offencePokemon.other_setting) &&
    (move.damage_class_number === MOVE_DAMAGE_CLASS_PHYSICAL ||
     photonGeyserUsesAttack) &&
    !isKonjou(offencePokemon) &&
    !isKaragenkiMove(move)
  ) {
    a = calc_五捨五超入_gosutegoire(a * per_050);
  }

  // 7番の補正
  a = calc_五捨五超入_gosutegoire((a * damageRateCalced) / 4096);

  return a;
}
/**
 *
 * @param a 五捨五超入したい数値
 * @returns 五捨五超入された値
 */
// calc_五捨五超入_gosutegoire は lib/damage/core-utils へ移動

/**
 * タイプ相性での倍率計算をして倍率を返す(テラスタルもここで考慮)
 * @param offencePokemon
 * @param deffencePokemon
 * @returns ダメージ倍率
 */
export function getCompatibilityTypeRate(
  offencePokemon: PokemonV2,
  deffencePokemon: PokemonV2,
  otherSetting: otherSetting
): number {
  let offenceType = offencePokemon.selected_move?.type || 1;
  // タイプ変化は特性→テラバースト→専用技→天候/フィールド→プレートの順で上書きする
  
  // めざめるダンスは使用者のタイプ（タイプ1/テラスタル）で攻撃する
  if (isRevelationDanceMove(offencePokemon.selected_move)) {
    offenceType = resolveRevelationDanceMoveType(offencePokemon);
  }

  // テクノバスターはカセットに応じてタイプが変化する
  if (isTechnoBlastMove(offencePokemon.selected_move)) {
    const technoBlastType = resolveTechnoBlastMoveType(offencePokemon);
    if (technoBlastType) {
      offenceType = technoBlastType;
    }
  }

  // マルチアタックはメモリに応じてタイプが変化する
  if (isMultiAttackMove(offencePokemon.selected_move)) {
    const multiAttackType = resolveMultiAttackMoveType(offencePokemon);
    if (multiAttackType) {
      offenceType = multiAttackType;
    }
  }

  // うるおいボイス特性：音技を水タイプに変更
  if (
    isUruoiVoice(offencePokemon) &&
    isOtoMove(offencePokemon.selected_move)
  ) {
    offenceType = POKEMON_TYPE_WATER;
  } else if (
    isFailySkin(offencePokemon) &&
    offenceType === POKEMON_TYPE_NORMAL
  ) {
    offenceType = POKEMON_TYPE_FAIRY;
  }
  if (isTerabrastMove(offencePokemon.selected_move) && offencePokemon.terasu_type) {
    offenceType = offencePokemon.terasu_type
  }

  // ステラタイプのテラバーストの特殊処理
  if (!isNormalSkin(offencePokemon) && isTerabrastMove(offencePokemon.selected_move) && offencePokemon.terasu_type === 19) {
    // ステラタイプのテラバーストは防御側がテラスタルしているかで相性が変わる
    if (deffencePokemon.terasu_type && deffencePokemon.terasu_type > 0) {
      return per_200; // 防御側がテラスタルしている場合は効果抜群(2.0倍)
    } else {
      return per_100; // 防御側がテラスタルしていない場合は等倍(1.0倍)
    }
  }

  // テラパゴス(ステラフォルム)のテラクラスターの特殊処理
  if (!isNormalSkin(offencePokemon) && offencePokemon.selected_move?.id === 906 && offencePokemon.id === 10277) {
    // テラパゴス(ステラフォルム)のテラクラスターは「ステラ」タイプとして扱う
    // ステラタイプのテラクラスターは防御側がテラスタルしているかで相性が変わる
    if (deffencePokemon.terasu_type && deffencePokemon.terasu_type > 0) {
      return per_200; // 防御側がテラスタルしている場合は効果抜群(2.0倍)
    } else {
      return per_100; // 防御側がテラスタルしていない場合は等倍(1.0倍)
    }
  }

  // ツタこんぼう使用時のオーガポンのタイプ変更
  if (offencePokemon.selected_move?.id === 904) { // ツタこんぼうの技ID
    // オーガポンの場合、持っているお面によってタイプを変更
    if (offencePokemon.id === 1017 || // オーガポン（みどりのめん）
        offencePokemon.id === 10273 || // オーガポン（いどのめん）
        offencePokemon.id === 10274 || // オーガポン（かまどのめん）
        offencePokemon.id === 10275) { // オーガポン（いしずえのめん）
      
      // 持っているアイテムに応じてタイプを変更
      if (offencePokemon.selected_item_id === 2107) { // かまどのめん
        offenceType = POKEMON_TYPE_FIRE;
      } else if (offencePokemon.selected_item_id === 2106) { // いどのめん
        offenceType = POKEMON_TYPE_WATER;
      } else if (offencePokemon.selected_item_id === 2108) { // いしずえのめん
        offenceType = POKEMON_TYPE_ROCK;
      }
      // みどりのめんまたはアイテムなしの場合はくさタイプのまま（デフォルト）
    }
  }

  // レイジングブル使用時のパルデアケンタロスのタイプ変更
  if (offencePokemon.selected_move?.id === 873) { // レイジングブルの技ID
    const pokemonId = offencePokemon.id;
    
    if (pokemonId === 10250) { // パルデアケンタロス(コンバット)
      offenceType = POKEMON_TYPE_FIGHTING;
    } else if (pokemonId === 10251) { // パルデアケンタロス(ブレイズ)
      offenceType = POKEMON_TYPE_FIRE;
    } else if (pokemonId === 10252) { // パルデアケンタロス(ウォーター)
      offenceType = POKEMON_TYPE_WATER;
    }
    // 通常のケンタロスや他のポケモンの場合はノーマルタイプのまま
  }

  // エアロック・ノーてんき特性チェック（天気無効化）
  const weatherBlocked = hasWeatherBlockAbility(deffencePokemon);

  // ウェザーボール使用時の天気対応タイプ変更
  if (isWeatherBallMove(offencePokemon.selected_move) && !weatherBlocked) {
    if (otherSetting.weather === WEATHER_HARE || otherSetting.weather === WEATHER_OOHIDERI) {
      offenceType = POKEMON_TYPE_FIRE; // ほのおタイプ
    } else if (otherSetting.weather === WEATHER_AME || otherSetting.weather === WEATHER_OOAME) {
      offenceType = POKEMON_TYPE_WATER; // みずタイプ
    } else if (otherSetting.weather === WEATHER_YUKI) {
      offenceType = POKEMON_TYPE_ICE; // こおりタイプ
    } else if (otherSetting.weather === WEATHER_SUNA) {
      offenceType = POKEMON_TYPE_ROCK; // いわタイプ
    }
  }

  // だいちのはどう使用時のフィールド対応タイプ変更
  if (isWavesOfTheEarthMove(offencePokemon.selected_move)) {
    if (otherSetting.battle_field === BATTLE_FIELD_GLASS) {
      offenceType = POKEMON_TYPE_GRASS; // くさタイプ
    } else if (otherSetting.battle_field === BATTLE_FIELD_MISUTO) {
      offenceType = POKEMON_TYPE_FAIRY; // フェアリータイプ
    } else if (otherSetting.battle_field === BATTLE_FIELD_PSYCHO_SAIKO) {
      offenceType = POKEMON_TYPE_PSYCHIC; // エスパータイプ
    } else if (otherSetting.battle_field === BATTLE_FIELD_EREKI) {
      offenceType = POKEMON_TYPE_ELECTRIC; // でんきタイプ
    }
  }

  // アルセウスのさばきのつぶて（Judgment）はプレートに応じてタイプが変化
  const normalizedSpeciesId =
    offencePokemon.species_id != null ? Number(offencePokemon.species_id) : undefined;
  const isArceus = normalizedSpeciesId === ARCEUS_SPECIES_ID || offencePokemon.id === ARCEUS_SPECIES_ID;
  if (offencePokemon.selected_move?.id === 449 && isArceus) {
    const plateType = getPlateType(offencePokemon.selected_item_id);
    if (plateType !== null) {
      offenceType = plateType;
    }
  }

  // ノーマルスキンは使用する技を全てノーマルタイプにする
  if (isNormalSkin(offencePokemon)) {
    offenceType = POKEMON_TYPE_NORMAL;
  }

  // おおひでり（ひざしがとてもつよい）はみずタイプの攻撃技を無効化する
  if (otherSetting.weather === WEATHER_OOHIDERI && !weatherBlocked && offenceType === POKEMON_TYPE_WATER) {
    return 0;
  }

  // おおあめ（つよいあめ）はほのおタイプの攻撃技を無効化する
  if (otherSetting.weather === WEATHER_OOAME && !weatherBlocked && offenceType === POKEMON_TYPE_FIRE) {
    return 0;
  }

  // 特性による技タイプ無効化チェック（ウェザーボールとだいちのはどうのタイプ変更後に実行）
  if (deffencePokemon.selected_ability) {
    // 水タイプ技無効化
    if ((isChosui(deffencePokemon) || 
         isYobimizu(deffencePokemon) || 
         isKansouHada(deffencePokemon)) && 
        offenceType === POKEMON_TYPE_WATER) {
      return 0;
    }
    
    // ほのおタイプ技無効化
    if ((isMoraibi(deffencePokemon) || 
         isKongariBody(deffencePokemon)) && 
        offenceType === POKEMON_TYPE_FIRE) {
      return 0;
    }
    
    // 草タイプ技無効化
    if (deffencePokemon.selected_ability.name_ja === 'そうしょく' && 
        offenceType === POKEMON_TYPE_GRASS) {
      return 0;
    }
    
    // 地面タイプ技無効化
    if ((deffencePokemon.selected_ability.name_ja === 'どしょく' || 
         isHuyuu(deffencePokemon)) && 
        offenceType === POKEMON_TYPE_GROUND) {
      return 0;
    }
    
    // 電気タイプ技無効化
    if ((isHiraishin(deffencePokemon) || 
         isDenkiEngine(deffencePokemon) || 
         isChikuden(deffencePokemon)) && 
        offenceType === POKEMON_TYPE_ELECTRIC) {
      return 0;
    }
  }

  // 防御側タイプ（アルセウスのプレート考慮）
  let deffenceTypeList = getArceusEffectiveType(deffencePokemon as any);
  // 防御側のテラスタイプによる調整（ステラタイプの場合は元のタイプを維持）
  if (deffencePokemon.terasu_type && deffencePokemon.terasu_type > 0 && deffencePokemon.terasu_type !== POKEMON_TYPE_STERA) {
    deffenceTypeList = [deffencePokemon.terasu_type];
  }

  // フリーズドライの特殊効果: 氷タイプが水タイプに効果抜群
  if (isFreezeDryMove(offencePokemon.selected_move) &&
      offenceType === POKEMON_TYPE_ICE &&
      deffenceTypeList.includes(POKEMON_TYPE_WATER)) {
    return per_200; // 2.0倍で固定
  }

  // ステラタイプの一般的な処理（テラバーストとテラクラスター以外）
  if (offenceType === POKEMON_TYPE_STERA) {
    // ステラタイプは防御側がテラスタルしているかで相性が変わる
    if (deffencePokemon.terasu_type && deffencePokemon.terasu_type > 0) {
      return per_200; // 防御側がテラスタルしている場合は効果抜群(2.0倍)
    } else {
      return per_100; // 防御側がテラスタルしていない場合は等倍(1.0倍)
    }
  }

  let res = 1.0;
  const deffenceType1 = deffenceTypeList[0];
  const r1 = getDamageRelations(deffenceType1 as any);
  if (r1.double_damage_from.includes(offenceType)) {
    res *= per_200;
  } else if (r1.half_damage_from.includes(offenceType)) {
    res *= per_050;
  } else if (r1.no_damage_from.includes(offenceType)) {
    if (!canScrappy(offencePokemon)) {
      res *= 0;
    }
  }
  if (deffenceTypeList.length === 2) {
    const deffenceType2 = deffenceTypeList[1];
    const r2 = getDamageRelations(deffenceType2 as any);
    if (r2.double_damage_from.includes(offenceType)) {
      res *= per_200;
    } else if (r2.half_damage_from.includes(offenceType)) {
      res *= per_050;
    } else if (r2.no_damage_from.includes(offenceType)) {
      if (!canScrappy(offencePokemon)) {
        res *= 0;
      }
    }
  }

  // らんきりゅう：ひこうタイプ弱点（でんき/いわ/こおり）技のダメージを半減する
  if (
    otherSetting.weather === WEATHER_RANKIRYUU &&
    !weatherBlocked &&
    deffenceTypeList.includes(POKEMON_TYPE_FLYING) &&
    (offenceType === POKEMON_TYPE_ELECTRIC || offenceType === POKEMON_TYPE_ROCK || offenceType === POKEMON_TYPE_ICE)
  ) {
    res *= per_050;
  }
  return res;
}


/**
 * 攻める側のタイプ相性(タイプ一致)による倍率計算
 * @param move
 * @param offencePokemon
 * @returns
 */
function calcOffenceMoveTypeRate(
  move: Move,
  offencePokemon: PokemonV2,
  otherSetting?: otherSetting,
  deffencePokemon?: PokemonV2,
  attackMode: boolean = false
): number {
  // 攻撃モードではテラスタイプ補正の扱いが異なるためフラグで分岐する
  let moveType = move.type;

  // めざめるダンスは使用者のタイプ（タイプ1/テラスタル）で攻撃する（ステラはタイプが変わらない）
  if (isRevelationDanceMove(move)) {
    moveType = resolveRevelationDanceMoveType(offencePokemon);
  }

  // テクノバスターはカセットに応じてタイプが変化する
  if (isTechnoBlastMove(move)) {
    const technoBlastType = resolveTechnoBlastMoveType(offencePokemon);
    if (technoBlastType) {
      moveType = technoBlastType;
    }
  }

  // マルチアタックはメモリに応じてタイプが変化する
  if (isMultiAttackMove(move)) {
    const multiAttackType = resolveMultiAttackMoveType(offencePokemon);
    if (multiAttackType) {
      moveType = multiAttackType;
    }
  }

  // うるおいボイス特性：音技を水タイプに変更
  if (
    isUruoiVoice(offencePokemon) &&
    isOtoMove(move)
  ) {
    moveType = POKEMON_TYPE_WATER;
  } else if (
    isFailySkin(offencePokemon) &&
    moveType === POKEMON_TYPE_NORMAL
  ) {
    moveType = POKEMON_TYPE_FAIRY;
  } else if (isSkySkin(offencePokemon) && moveType === POKEMON_TYPE_NORMAL) {
    moveType = POKEMON_TYPE_FLYING;
  } else if (isErekiSkin(offencePokemon) && moveType === POKEMON_TYPE_NORMAL) {
    moveType = POKEMON_TYPE_ELECTRIC;
  } else if (isFreezeSkin(offencePokemon) && moveType === POKEMON_TYPE_NORMAL) {
    moveType = POKEMON_TYPE_ICE;
  }

  // テラバーストのタイプ変更処理
  if (isTerabrastMove(move) && offencePokemon.terasu_type) {
    moveType = offencePokemon.terasu_type;
  }

  // ウェザーボール使用時の天気対応タイプ変更
  if (isWeatherBallMove(move) && otherSetting) {
    // エアロック・ノーてんき特性チェック（天気無効化）
    const weatherBlocked = hasWeatherBlockAbility(offencePokemon) || hasWeatherBlockAbility(deffencePokemon);
    
    if (!weatherBlocked) {
      if (otherSetting.weather === WEATHER_HARE || otherSetting.weather === WEATHER_OOHIDERI) {
        moveType = POKEMON_TYPE_FIRE;
      } else if (otherSetting.weather === WEATHER_AME || otherSetting.weather === WEATHER_OOAME) {
        moveType = POKEMON_TYPE_WATER;
      } else if (otherSetting.weather === WEATHER_YUKI) {
        moveType = POKEMON_TYPE_ICE;
      } else if (otherSetting.weather === WEATHER_SUNA) {
        moveType = POKEMON_TYPE_ROCK;
      }
    }
  }

  // だいちのはどう使用時のフィールド対応タイプ変更
  if (isWavesOfTheEarthMove(move) && otherSetting) {
    if (otherSetting.battle_field === BATTLE_FIELD_GLASS) {
      moveType = POKEMON_TYPE_GRASS;
    } else if (otherSetting.battle_field === BATTLE_FIELD_MISUTO) {
      moveType = POKEMON_TYPE_FAIRY;
    } else if (otherSetting.battle_field === BATTLE_FIELD_PSYCHO_SAIKO) {
      moveType = POKEMON_TYPE_PSYCHIC;
    } else if (otherSetting.battle_field === BATTLE_FIELD_EREKI) {
      moveType = POKEMON_TYPE_ELECTRIC;
    }
  }

  const normalizedSpeciesId =
    offencePokemon.species_id != null ? Number(offencePokemon.species_id) : undefined;
  const isArceus = normalizedSpeciesId === ARCEUS_SPECIES_ID || offencePokemon.id === ARCEUS_SPECIES_ID;
  if (move.id === 449 && isArceus) {
    const plateType = getPlateType(offencePokemon.selected_item_id);
    if (plateType !== null) {
      moveType = plateType;
    }
  }

  // ノーマルスキンは使用する技を全てノーマルタイプにする
  if (isNormalSkin(offencePokemon)) {
    moveType = POKEMON_TYPE_NORMAL;
  }

  // テラパゴス(ステラフォルム)のテラクラスターの特殊処理
  if (!isNormalSkin(offencePokemon) && move.id === 906 && offencePokemon.id === 10277) {
    // テラクラスターはステラタイプとして扱う
    moveType = POKEMON_TYPE_STERA;
    // タイプ一致なので1.2倍を返す
    return per_120;
  }


  // おかしいかも？
  // if (offencePokemon.terasu_type) {
  //   if (moveType === offencePokemon.terasu_type) {
  //     if (offencePokemon.type_id_list.includes(moveType)) {
  //       return per_225;
  //     }
  //     return per_200;
  //   }
  //   return per_150;
  // }
  if (offencePokemon.terasu_type) {
    if (offencePokemon.terasu_type === POKEMON_TYPE_STERA) {
      // ステラタイプの処理
      const effectiveTypesForStella = getArceusEffectiveType(offencePokemon);
      if (effectiveTypesForStella.includes(moveType)) {
        return per_200; // 元のタイプと技のタイプが一致: 2.0倍
      } else {
        return per_120; // 元のタイプと技のタイプが不一致: 1.2倍
      }
    } else {
      // 攻撃モードではテラスタイプ一致時のみテラ補正を反映する
      // 通常のテラスタイプの処理
      if (attackMode) {
        // 攻撃モード: テラスタイプと技のタイプが一致する場合のみ補正適用
        if (offencePokemon.terasu_type === moveType) {
          // アルセウスのプレートによるタイプ変化を考慮して一致判定を行う
          const effectiveTypesAttack = getArceusEffectiveType(offencePokemon);
          if (effectiveTypesAttack.includes(moveType)) {
            if (isTekiourixyoku(offencePokemon)) {
              return per_225;
            }
            return per_200;
          }
          return per_150; // テラスタイプと技のタイプが一致する場合の1.5倍
        }
        // 攻撃モードで一致しない場合は通常のSTABのみ
      } else {
        // 防御モード: 従来通りの処理（全技に補正）
        const effectiveTypesDefense = getArceusEffectiveType(offencePokemon);
        if (effectiveTypesDefense.includes(moveType)) {
          if (isTekiourixyoku(offencePokemon)) {
            return per_225;
          }
          return per_200;
        }
        return per_150; // 従来通りの1.5倍
      }
    }
  }

  const effectiveTypes = getArceusEffectiveType(offencePokemon);
  
  if (effectiveTypes.includes(moveType)) {
    if (isTekiourixyoku(offencePokemon)) {
      return per_200;
    }
    return per_150;
  }
  return per_100;

  /*
  if (offencePokemon.terasu_type) {
    if (
      offencePokemon.terasu_type === moveType &&
      isTekiourixyoku(offencePokemon) &&
      offencePokemon.type_id_list.includes(moveType)
    ) {
      return per_225;
    } else if (
      offencePokemon.terasu_type === moveType &&
      offencePokemon.type_id_list.includes(moveType)
    ) {
      return per_200;
    } else if (
      offencePokemon.terasu_type === moveType &&
      !offencePokemon.type_id_list.includes(moveType)
    ) {
      return per_150;
    } else if (
      offencePokemon.terasu_type === POKEMON_TYPE_STERA &&
      offencePokemon.type_id_list.includes(moveType)
    ) {
      return per_200;
    } else if (
      offencePokemon.terasu_type === POKEMON_TYPE_STERA &&
      !offencePokemon.type_id_list.includes(moveType)
    ) {
      return per_120;
    }
  }
  if (
    offencePokemon.type_id_list.includes(moveType) &&
    isTekiourixyoku(offencePokemon)
  ) {
    return per_200;
  }
  if (offencePokemon.type_id_list.includes(moveType)) {
    return per_150;
  }
  return per_100;
  */
}

// calcRankedValue は lib/damage/core-utils へ移動
